import "./SpirulinaLevels.css";

import FontSpirulina from '../../font_component/spirulina_font/FontSpirulina';

const levels = [
  { level: "Level 01", title: "Referrer", points: "30 Pts" },
  { level: "Level 02", title: "Retailer", points: "180 Pts" },
  { level: "Level 03", title: "Dealer", points: "645 Pts" },
  { level: "Level 04", title: "Distributor", points: "1305 Pts" },
  { level: "Level 05", title: "Promoter", points: "2340 Pts" },
];

export default function SpirulinaLevels() {
  return (
    <></>
    // <section className="levels-section">
    //   <div className="container">
    //   <h2 className="levels-heading">
    //     5-Level Structure Of <span><FontSpirulina  color="#3C9734"  weight="normal" >Spirulina</FontSpirulina></span>
    //   </h2>

    //   <div className="levels-row">
    //     {levels?.map((item, i) => (
    //       <div className="level-card" key={i}>
    //         <span className="level-badge">{item.level}</span>
    //         <h3>{item?.title}</h3>
    //         {/* <p className="points"><img src="/images/about/Group 40139.png" alt="icon"></img>  {item?.points}</p> */}
    //       </div>
    //     ))}
    //   </div>

    //   <div className="levels-note">
    //     As your network grows deeper, your total points increase
    //   </div>
    //   </div>
    // </section>
  );
}
